import * as yup from 'yup';

export const schema = yup.object({
  descricao: yup.string().required(),
  tipo: yup
    .object({
      label: yup.string().required(),
      value: yup.number().required(),
    })
    .required(),
});
